import {
    doppeActionTypeCreateSettingsResolvingFunction,
    doppeActionTypeDefineMetadata
} from '../../client-server-common/doppe-action-types/doppe-action-type';
import type {Values} from "@wix/devzai-utils-common";
import {
    DoppeActionTypeContentSpecialSettingsMetadata,
    DoppeAutoProductType,
    DoppeBusinessEntity
} from "../../client-server-common";

export const DoppeActionTypeDevViewerStorybookStories = {
    PageInfo: 'PageInfo',
    Form: 'Form',
    PageMediaViewCropping: 'PageMediaViewCropping',
    Modals: 'Modals',
    StoresCheckout: 'StoresCheckout',
    HoppStore: 'HoppStore',
    ApiTest: 'ApiTest',
    Locales: 'Locales',
    Colors: 'Colors',
} as const;

export type DoppeActionTypeDevViewerStorybookStories = Values<typeof DoppeActionTypeDevViewerStorybookStories>;

export namespace DoppeActionTypeDevViewerStorybook {
    export interface ActionSettings {
        story: DoppeActionTypeDevViewerStorybookStories;
    }
}

export const doppeActionTypeDevViewerStorybook = doppeActionTypeDefineMetadata<DoppeActionTypeDevViewerStorybook.ActionSettings>({
    id: 'io.bymo.action/dev-viewer-storybook',
    resolveActionSettings: doppeActionTypeCreateSettingsResolvingFunction({
        story: DoppeActionTypeDevViewerStorybookStories.PageInfo,
    }),
    actionSettingsMetadata: {
        contentSettingsMetadata: DoppeActionTypeContentSpecialSettingsMetadata.Ignored,
        supportsActionCtaButtons: false,
        supportsContentSections: false,
        hideableContentSettingsNames: {}
    },
    actionListItemSettingsMetadata: false,
    isWidgetOpener: true,
    canRenderInPage: true,
    skipReportingOnGoalAchievedOnActionButtonClick: true,
    resolveUsedBusinessEntities: actionSettings => {
        switch (actionSettings.story) {
            case DoppeActionTypeDevViewerStorybookStories.StoresCheckout: {
                return [
                    {businessEntity: DoppeBusinessEntity.WixAutoProductsList, id: DoppeAutoProductType.Latest}
                ];
            }
            case DoppeActionTypeDevViewerStorybookStories.HoppStore: {
                return [
                    {businessEntity: DoppeBusinessEntity.HoppAutoProductsList, id: DoppeAutoProductType.Latest}
                ];
            }
            default: {
                return [];
            }
        }
    }
});

